// removed by extract-text-webpack-plugin
module.exports = {"grid":"gridVideo-module_grid_1GL6j","result":"gridVideo-module_result__y9fZ"};


//////////////////
// WEBPACK FOOTER
// ./client/components/productList/gridVideo.module.css
// module id = 953
// module chunks = 1